import React from 'react';

const SvgClose = ({ stroke, type }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>{`Close (${type === 'x' ? 'X' : '-'})`}</title>

    {type === 'x' ? (
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <line
          x1="18"
          y1="18"
          x2="6"
          y2="6"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="18"
          y1="6"
          x2="6"
          y2="18"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    ) : (
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <defs>
          <rect id="path-1" x="0" y="0" width="24" height="24" />
        </defs>
        <g>
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <line
            x1="5"
            y1="12"
            x2="19"
            y2="12"
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    )}
  </svg>
);

export default SvgClose;
